// extracted by mini-css-extract-plugin
export var active = "CookBook-module--active--hMlvg";
export var container = "CookBook-module--container--cA24B";
export var content = "CookBook-module--content--SHPpT";
export var tab = "CookBook-module--tab--IM4eb";
export var tabContentTitle = "CookBook-module--tabContentTitle--nusD6";
export var tabs = "CookBook-module--tabs--NCREH";